import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { LoginForm } from 'components/index'
import styles from './Login.module.scss'
import chuLogo from 'assets/img/chu.svg'

function readSavedTheme() {
  if (typeof window === 'undefined') return 'light'
  try {
    return localStorage.getItem('theme') === 'dark' ? 'dark' : 'light'
  } catch (_) {
    return 'light'
  }
}

function Login() {
  const { t } = useTranslation('common')
  const [theme, setTheme] = useState(readSavedTheme)

  // Wave 4: title в табе браузера для страницы входа.
  useEffect(() => {
    document.title = `${t('login.title', 'Вход')} — ЧУ`
  }, [t])

  useEffect(() => {
    const root = document.documentElement
    if (theme === 'dark') root.setAttribute('data-theme', 'dark')
    else root.removeAttribute('data-theme')
    try {
      localStorage.setItem('theme', theme)
    } catch (_) {
      /* ignore */
    }
  }, [theme])

  const toggleTheme = () => setTheme((prev) => (prev === 'dark' ? 'light' : 'dark'))

  return (
    <div className={styles.wrapper}>
      <button
        type="button"
        className={styles.themeToggle}
        onClick={toggleTheme}
        aria-label={t('common.toggle_theme', 'Переключить тему')}
        title={t('common.toggle_theme', 'Переключить тему')}
      >
        {theme === 'dark' ? '☀' : '☾'}
      </button>

      <div className={styles.brand}>
        <div className={styles.brand__inner}>
          <div className={styles.brand__logo}>
            <img src={chuLogo} alt={t('loginPage.brand_alt')} />
          </div>
          <h1 className={styles.brand__title}>{t('loginPage.brand_title')}</h1>
          <p className={styles.brand__subtitle}>
            {t('loginPage.brand_subtitle')}
          </p>
          <div className={styles.brand__divider} />
          <ul className={styles.brand__features}>
            <li className={styles.brand__feature}>
              <span className={styles.brand__dot} />
              <span>{t('loginPage.feature_1')}</span>
            </li>
            <li className={styles.brand__feature}>
              <span className={styles.brand__dot} />
              <span>{t('loginPage.feature_2')}</span>
            </li>
            <li className={styles.brand__feature}>
              <span className={styles.brand__dot} />
              <span>{t('loginPage.feature_3')}</span>
            </li>
          </ul>
        </div>
        <div className={styles.brand__footer}>
          {t('loginPage.footer', { year: new Date().getFullYear() })}
        </div>
      </div>

      <div className={styles.form__panel}>
        <div className={styles.form__card}>
          <LoginForm />
        </div>
      </div>
    </div>
  )
}

export default Login
